import React from "react";
import PropTypes from "prop-types";
const List = ({ children }) => {

    const displayData = () => {
        if (children) {
            return children
        }
    }
    return (
        <React.Fragment>
            {displayData()}
        </React.Fragment>
    )
};

List.propTypes = {
    children: PropTypes.array
}

export default List;